// src/pages/Registro/formRegistro/formRegistro.jsx
import React from "react";

export default function FormRegistro({
  nomeCompleto,
  email,
  cpf,                // 👈 NOVO
  condominioInfo,
  errorMessage,
  successMessage,
  isLoading,
  onChangeNome,
  onChangeEmail,
  onChangeCpf,        // 👈 NOVO
  onChangeCondominio,
  onSubmit,
  onClickVoltar,
  onClickContratar
}) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 via-green-100 to-emerald-100 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-2xl space-y-8">
        <div className="text-center">
          <h2 className="text-[5vh] font-bold text-gray-800 tracking-tight">
            Cadastro no SAP
          </h2>
          <p className="mt-2 text-[2.5vh] text-gray-600">
            Solicite seu acesso ao sistema
          </p>
        </div>

        <div className="p-0">
          {/* Mensagens de erro e sucesso */}
          {errorMessage && (
            <div className="mb-4 p-3 rounded-lg bg-red-50 border border-red-200">
              <p className="text-red-700 text-sm font-medium">{errorMessage}</p>
            </div>
          )}

          {successMessage && (
            <div className="mb-4 p-3 rounded-lg bg-green-50 border border-green-200">
              <p className="text-green-700 text-sm font-medium">
                {successMessage}
              </p>
            </div>
          )}

          <form onSubmit={onSubmit} className="space-y-6">
            <p
              onClick={onClickContratar}
              className="text-start text-sm text-emerald-700 cursor-pointer hover:underline hover:text-emerald-900 transition"
            >
              Deseja contratar nosso serviço para seu condomínio?
            </p>

            {/* Nome Completo */}
            <div>
              <p className="text-gray-700 font-semibold text-[2vh] mb-2">
                Nome Completo
              </p>
              <label htmlFor="nomeCompleto" className="sr-only">
                Nome completo
              </label>
              <input
                id="nomeCompleto"
                type="text"
                required
                value={nomeCompleto}
                onChange={onChangeNome}
                className="w-full px-5 py-3.5 border border-green-300 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-200 bg-white/70 backdrop-blur-sm placeholder-gray-500 text-gray-800"
                placeholder="Digite seu nome completo"
              />
            </div>

            {/* CPF */}
            <div>
              <p className="text-gray-700 font-semibold text-[2vh] mb-2">
                CPF
              </p>
              <label htmlFor="cpf" className="sr-only">
                CPF
              </label>
              <input
                id="cpf"
                type="text"
                required
                value={cpf}
                onChange={onChangeCpf}
                inputMode="numeric"
                maxLength={14} // 000.000.000-00
                className="w-full px-5 py-3.5 border border-green-300 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-200 bg-white/70 backdrop-blur-sm placeholder-gray-500 text-gray-800"
                placeholder="000.000.000-00"
              />
              <p className="mt-1 text-xs text-gray-500">
                Informe seu CPF para validação do cadastro.
              </p>
            </div>

            {/* Email */}
            <div>
              <p className="text-gray-700 font-semibold text-[2vh] mb-2">
                Email
              </p>
              <label htmlFor="email" className="sr-only">
                Email
              </label>
              <input
                id="email"
                type="email"
                required
                value={email}
                onChange={onChangeEmail}
                className="w-full px-5 py-3.5 border border-green-300 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-200 bg-white/70 backdrop-blur-sm placeholder-gray-500 text-gray-800"
                placeholder="seu.email@exemplo.com"
              />
            </div>

            {/* Informação do Condomínio */}
            <div>
              <p className="text-gray-700 font-semibold text-[2vh] mb-2">
                Código ou Nome do Condomínio
              </p>
              <label htmlFor="condominioInfo" className="sr-only">
                Código ou nome do condomínio
              </label>
              <input
                id="condominioInfo"
                type="text"
                required
                value={condominioInfo}
                onChange={onChangeCondominio}
                className="w-full px-5 py-3.5 border border-green-300 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-200 bg-white/70 backdrop-blur-sm placeholder-gray-500 text-gray-800"
                placeholder={"Digite o código ou nome do condomínio"}
              />
              <p className="mt-2 text-sm text-gray-600">
                Verifique com o responsável do condomínio o código ou nome
                correto
              </p>
            </div>

            {/* Botões */}
            <div className="flex flex-col sm:flex-row gap-3">
              <button
                type="button"
                onClick={onClickVoltar}
                className="flex-1 bg-white border border-green-300 text-gray-700 py-3 px-4 rounded-xl font-semibold shadow-md hover:bg-gray-50 focus:ring-4 focus:ring-gray-200 transition-all duration-200 transform hover:scale-[1.02] active:scale-95"
              >
                <span className="flex items-center justify-center">
                  <svg
                    className="w-5 h-5 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M10 19l-7-7m0 0l7-7m-7 7h18"
                    />
                  </svg>
                  Voltar
                </span>
              </button>

              <button
                type="submit"
                disabled={isLoading}
                className={`flex-1 bg-gradient-to-r from-primary-500 to-primary-600 text-white py-3 px-4 rounded-xl font-semibold shadow-lg focus:ring-4 focus:ring-primary-200 transition-all duration-200 transform hover:scale-[1.02] active:scale-95 ${
                  isLoading
                    ? "opacity-70 cursor-not-allowed"
                    : "hover:from-primary-600 hover:to-primary-700"
                }`}
              >
                <span className="flex items-center justify-center">
                  {isLoading ? (
                    <>
                      <svg
                        className="animate-spin h-5 w-5 mr-2"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      Enviando...
                    </>
                  ) : (
                    <>
                      <svg
                        className="w-5 h-5 mr-2"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                      Solicitar Cadastro
                    </>
                  )}
                </span>
              </button>
            </div>
          </form>
        </div>

        <div className="text-center">
          <p className="text-xs text-gray-500">
            © {new Date().getFullYear()} CMD Automação
          </p>
        </div>
      </div>
    </div>
  );
}
